/* eslint-disable */

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ScrollTop from "./ScrollTop.js";
import SideBox from "./SideBox.js";
import Content from "../components/ContentHeader.js";
import Route from "../components/Route.js";
import { getAllConference } from "../api/CenferenceApi.js";

// css
import "../css/News.css";
import "../css/NewsPage.css";
import "../css/Conference.css";

// img
import NoImage from "../assets/img/no_image.png";

const tabs = [
  { label: "ALL", filter: null },
  { label: "ONLINE", filter: "ONLINE" },
  { label: "OFFLINE", filter: "OFFLINE" },
  // {
  //   label: "2024 Automation Anywhere 생성형 AI 웨비나",
  //   filter: "2024 Automation Anywhere 생성형 AI 웨비나"
  // }
];

function Conference() {
  const [selectedTab, setSelectedTab] = useState(tabs[1].filter);
  const [sampleData, setSampleData] = useState([]);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-10966372634";
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", "AW-10966372634");

      gtag("event", "conversion", {
        send_to: "AW-10966372634/PojcCL3Py9wDEJqilu0o",
      });
    };

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  const handleTabClick = (tabLabel) => {
    setSelectedTab(tabLabel);
  };

  const filterDataByTab = () => {
    if (selectedTab === "ALL") {
      return sampleData;
    } else if (selectedTab === "2024 Automation Anywhere 생성형 AI 웨비나") {
      return sampleData.filter(
        (item) => item.division === "ONLINE" || item.division === selectedTab
      );
    } else {
      return sampleData.filter((item) => item.division === selectedTab);
    }
  };

  const alldata = async () => {
    try {
      const result = await getAllConference();
      // 최신순
      const sortedData = result.sort(
        (a, b) => new Date(b.published_date) - new Date(a.published_date)
      );
      setSampleData(sortedData);
    } catch (error) {
      console.error("API 호출에 실패했습니다:", error);
    }
  };
  useEffect(() => {
    alldata();
  }, []);

  return (
    <div className="webinar_wrap">
      <ScrollTop />
      <SideBox />

      <Content
        title="CONFERENCE"
        title1="콘텐츠를 통해 인사이트를 얻어보세요"
      />

      <Route route1="MEDIA" route2="CONFERENCE" />

      <div className="content_bg">
        <h1>컨퍼런스 · 웨비나 · 세미나 아카이브</h1>
        <div className="container">
          <div className="news_wrap news_wrap_top">
            <div className="title">
              <ul className="contents1 news_list news_list_flex">
                {tabs.map((tab, index) => (
                  <li
                    key={index}
                    onClick={() => handleTabClick(tab.label)}
                    className={selectedTab === tab.label ? "news_active" : ""}
                  >
                    <span>{tab.label}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="news_wrap_item">
              {filterDataByTab().map((item) => (
                <Link
                  key={item.id}
                  to={`./detail?id=${item.id}`}
                  className="news_first news"
                >
                  <div className="news_img">
                    <img src={item.img || NoImage} alt="이미지" />
                  </div>
                  <div className="news_thumbnail">
                    <div
                      className={`news_badge contents3 ${
                        item.division === "OFFLINE" ? "badge_off" : ""
                      }`}
                    >
                      <span>{item.division}</span>
                    </div>
                    <p
                      className={`news_data ${
                        item.division === "OFFLINE" ? "data_off" : ""
                      }`}
                    >
                      {new Date(item.published_date).toLocaleDateString(
                        "ko-KR",
                        {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        }
                      )}{" "}
                      {item.event_time && <span>| {item.event_time}</span>}
                    </p>
                    <h2 className="news_title">{item.title}</h2>
                    <p className="news_content">{item.content_explain}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Conference;
